import React from "react";
import PropTypes from "prop-types";
import subscribe from "venuescanner-js/react/helpers/subscribe";
import SrpContainer from "../../containers/SrpContainer";
import EventTypeField from "venuescanner-js/react/components/SelectField/EventTypeField";
import classes from "./styles.module.scss";

export const SrpNavEventTypeField = ({
  srpContainer,
  stopUrlRefresh = false,
}) => {
  const { query } = srpContainer.state;
  const value = query.event_type || query.tags || null;

  return (
    <EventTypeField
      value={value}
      containerClassName={classes.SrpNavFieldContainer}
      onChange={(val) => {
        srpContainer.patchQuery({
          event_type: val || null,
          tags: val?.value || val,
          map_pages: [1, 2, 3],
          page: 1,
        });
        if (srpContainer.hasValidLocation && !stopUrlRefresh)
          srpContainer.refresh({ refresh: true });
      }}
      clearButton
    />
  );
};

SrpNavEventTypeField.propTypes = {
  srpContainer: PropTypes.instanceOf(SrpContainer).isRequired,
};

export default subscribe({ SrpContainer })(SrpNavEventTypeField);
